export default __webpack_public_path__ + "static/7-d67cabfe77201b4a16e4cbaa622b9e6f.jpg";